// extracted by mini-css-extract-plugin
export default {"card":"Notification_card__REdsI","closeBtn":"Notification_closeBtn__pcWcJ"};